// src/ui/components.js — componentes UI compartidos.
//
// Extraído de js/app.js (sub-fase 3.3 del refactor).
//
// El doc PROMPT_REFACTORING.md menciona también `toast` para esta sub-fase,
// pero esa función NO existe en el código vivo (drift doc vs código,
// reportado en el commit message). Solo se mueven las 2 funciones que
// existen.
//
// Dependencias salientes:
//   - getNormalizedDB                                       → import desde ../core/db.js
//   - getActiveMembershipsForUser, MAX_GROUPS_PER_USER,
//     getGroupDisplayName                                   → import desde ../core/groups.js (sub-fase 3.6)
//
// Sub-fase 3.6 retiró el mini-bridge transitorio que vivía aquí: los 3
// símbolos de groups ahora viven en src/core/groups.js y se consumen por
// import directo, no por window.* lazy.

import { getNormalizedDB } from '../core/db.js'
import { getActiveMembershipsForUser, MAX_GROUPS_PER_USER, getGroupDisplayName } from '../core/groups.js'
// Side-effect import: registra window.openJugadoresModal + inyecta CSS del
// modal (idempotente). Lo necesita el subtítulo clickeable del bar abajo.
import '../ui/jugadores-modal.js'

// ─── Barra de grupo activo (header de las vistas con sesión) ───────────────

export const renderActiveGroupBar = (codigo) => {
  const db = getNormalizedDB()
  const grupo = db.grupos[codigo]
  if (!grupo) return ''
  const reachedLimit = getActiveMembershipsForUser().length >= MAX_GROUPS_PER_USER
  const jugadoresCount = grupo.jugadores?.length || 0
  // 26-may-2026: el subtítulo "X jugadores en este grupo" pasa a botón
  // clickeable "👥 Ver jugadores · N" → abre modal con la lista (jugadores-modal.js).
  // event.stopPropagation evita disparar openGroupSelector del button outer.
  const verJugadoresLabel = `&#128101; Ver jugadores &middot; ${jugadoresCount}`

  return `
        <div style="display:grid;grid-template-columns:1fr 104px;gap:.5rem;align-items:stretch;margin-bottom:.75rem;">
            <button type="button" onclick="openGroupSelector('${codigo}')" style="min-height:60px;border:1px solid rgba(117,170,219,.2);border-radius:9px;background:rgba(255,255,255,.045);color:var(--white);padding:.7rem .72rem;text-align:left;overflow:hidden;">
                <strong style="display:block;font-size:.84rem;line-height:1.08;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${getGroupDisplayName(grupo)} &#9662;</strong>
                <span role="button" tabindex="0" onclick="event.stopPropagation(); openJugadoresModal('${codigo}');" onkeydown="if(event.key==='Enter'||event.key===' '){event.stopPropagation();event.preventDefault();openJugadoresModal('${codigo}');}" style="display:block;color:var(--text-muted);font-size:.68rem;margin-top:.4rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;transition:color .15s ease;" onmouseover="this.style.color='var(--celeste)'" onmouseout="this.style.color='var(--text-muted)'">${verJugadoresLabel}</span>
            </button>
            <button type="button" ${reachedLimit ? 'disabled' : `onclick="window.location.hash='/crear-grupo'"`} style="min-height:60px;border:1px solid ${reachedLimit ? 'rgba(255,255,255,.08)' : 'rgba(117,170,219,.3)'};border-radius:9px;background:${reachedLimit ? 'rgba(255,255,255,.04)' : 'linear-gradient(135deg,#8bc0f0 0%,var(--celeste) 100%)'};color:${reachedLimit ? 'var(--text-muted)' : '#06111f'};font-size:.64rem;line-height:1.05;font-weight:900;cursor:${reachedLimit ? 'not-allowed' : 'pointer'};">
                ${reachedLimit ? '5/5' : '+ Otro grupo'}
            </button>
            <button type="button" onclick="shareActiveGroup('${codigo}')" aria-label="Invitar amigos" style="grid-column:1 / -1;min-height:38px;border:1px solid rgba(117,170,219,.24);border-radius:9px;background:rgba(117,170,219,.11);color:var(--celeste);font-size:.78rem;font-weight:900;letter-spacing:.02em;cursor:pointer;">
                INVITAR AMIGOS
            </button>
        </div>
    `
}

// ─── Bottom nav de las vistas con grupo activo ─────────────────────────────
// Función pura — no toca DB ni globales. Solo recibe codigo + activeTab.

export const renderBottomNav = (codigo, activeTab) => {
  return `
        <nav class="bottom-nav">
            <a href="#/g/${codigo}" class="${activeTab === 'grupo' ? 'active' : ''}" data-icon="⚽" aria-label="Mis grupos"><span class="nav-label">Mis<br>grupos</span></a>
            <a href="#/ranking/${codigo}" class="${activeTab === 'ranking' ? 'active' : ''}" data-icon="🏆" aria-label="Ranking"><span class="nav-label">Ranking</span></a>
            <a href="#/tribuna/${codigo}" class="${activeTab === 'tribuna' ? 'active' : ''}" data-icon="📣" aria-label="Tribuna Pública"><span class="nav-label">Tribuna<br>Pública</span></a>
            <a href="#/prode/${codigo}" class="${activeTab === 'prode' ? 'active' : ''}" data-icon="🌎" aria-label="Prode"><span class="nav-label">Prode</span></a>
            <a href="#/perfil/${codigo}" class="${activeTab === 'perfil' ? 'active' : ''}" data-icon="👤" aria-label="Perfil"><span class="nav-label">Perfil</span></a>
        </nav>
    `
}

// ─── Bridge transitorio a window.* (sub-fase 3.3 → FASE 4) ─────────────────

if (typeof window !== 'undefined') {
  window.renderActiveGroupBar = renderActiveGroupBar
  window.renderBottomNav      = renderBottomNav
}
